module.exports = __webpack_public_path__ + "img/pro_3.b16dd2d3.png";